// ShipLists.tsx - Refactored main component
import React, { useState } from 'react';
import { useFetchAllShiplists } from '@ais-ui/api';
import {
  Accordion,
  Button,
  CardContent,
  CardDescription,
  CardFooter,
  InfiniteScroll,
  Input,
  LoadingSpinner,
} from '@ais-ui/ui-core';
import { useLocalization } from '@ais-ui/locale-management';
import { NoItemsEmptyStateList } from '../../../components/EmptyList';
import { CreateShiplist } from '../Mutations/shiplist/CreateShiplist';
import { useShiplistFilters } from './useShiplistFilters';
import { ShiplistSort } from './ShiplistSort';
import { ShiplistFilter } from './ShiplistFilter';
import { ShipListItem } from './ShipListItem';

export const ShipLists = () => {
  const { messages } = useLocalization();
  const [search, setSearch] = useState<string>('');
  const [showCreateDialog, setShowCreateDialog] = useState(false);

  const { data, isLoading } = useFetchAllShiplists();
  const shiplists = data?.records ? data.records : [];

  const {
    filteredAndSortedShiplists,
    shiplistFilters,
    setShiplistFilters,
    sortConfig,
    setSortConfig,
  } = useShiplistFilters(shiplists || [], search);

  return (
    <>
      {/* Controls section - outside CardContent to avoid overflow-hidden */}
      <div className="px-6 pb-4">
        <CardDescription className="mb-4">
          {messages.shiplistsSubtitle}
        </CardDescription>
        <div className="flex gap-2">
          <Input
            id="search"
            placeholder={messages.shiplistsSearchShiplists}
            className="h-10 flex-1"
            value={search}
            onChange={(event) => setSearch(event.currentTarget.value)}
          />
          <ShiplistSort sortConfig={sortConfig} setSortConfig={setSortConfig} />
          <ShiplistFilter
            shiplistFilters={shiplistFilters}
            setShiplistFilters={setShiplistFilters}
            shiplists={shiplists}
          />
        </div>
      </div>

      {/* Content section */}
      <CardContent className="flex-1 flex flex-col overflow-hidden pt-0">
        {!isLoading && shiplists?.length === 0 && (
          <NoItemsEmptyStateList
            entity="shiplist"
            srcImage="empty_list_bro.png"
          >
            <Button
              id="shiplists-create-button"
              onClick={() => setShowCreateDialog(true)}
              className="w-full h-10"
            >
              Create shiplist
            </Button>
          </NoItemsEmptyStateList>
        )}

        {isLoading && <LoadingSpinner />}

        {!isLoading && shiplists?.length !== 0 && (
          <Accordion
            className="flex-1 flex flex-col overflow-hidden"
            type="single"
            collapsible
          >
            <InfiniteScroll
              items={filteredAndSortedShiplists}
              limit={30}
              observeResize={true}
              className="flex-grow p-0 overflow-y-auto border rounded-lg"
              renderItem={(shiplist) => {
                return <ShipListItem key={shiplist.id} shiplist={shiplist} />;
              }}
            />
          </Accordion>
        )}
      </CardContent>

      <CardFooter className="flex flex-grow-0 flex-col items-end min-h-52">
        {shiplists?.length !== 0 && (
          <Button
            id="shiplists-create-button"
            onClick={() => setShowCreateDialog(true)}
          >
            Create
          </Button>
        )}

        {showCreateDialog && (
          <CreateShiplist
            showDialog={showCreateDialog}
            setShowDialog={setShowCreateDialog}
          />
        )}
      </CardFooter>
    </>
  );
};
